/**
 * PLP template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';
import ThemeAccordian from "./partials/ThemeAccordian";
import SimpleCarousel from './partials/SimpleCarousel';

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
const NAME = 'Product Details Page';

let global = {};

const hint = document.querySelector('#product-hint-popup');
const hintForm = hint.querySelector('form');
const notify = document.querySelector('#product-notify-popup');
const notifyForm = notify.querySelector('form');
const chart = document.querySelector('#product-ring-chart');
const carouselEl = document.querySelector('[data-carousel="simple"]')

const addToCartButtonDoms = document.querySelectorAll(
	`[data-add-to-cart-button]`
);

const selectedVariantDom = document.querySelector(`[data-selected-variant]`);

/**
 * onPopUpBtn - Handle the popup button click
 * @param {*} popup
 */
const onPopUpBtn = (popup) => {
	Logger.info(`${NAME} > onPopUpBtn`);
	popup.dataset.show = popup.dataset.show === 'true' ? 'false' : 'true';
};

/**
 * onHintFormSubmit - Handle the hint form submit
 * @param {*} e
 */
function onHintFormSubmit(e) {
	Logger.info(`${NAME} > onHintFormSubmit`);
	e.preventDefault();
	const productTitle = hintForm.elements['ProductTitle'].value;
	const productUrl = hintForm.elements['ProductUrl'].value;
	const senderName = hintForm.elements['SenderName'].value;
	const recipientName = hintForm.elements['RecipientName'].value
	const recipientEmail = hintForm.elements['RecipientEmail'].value;
	const hintSubject = `${recipientName} has a little hint for you...`;

	const hintBody = `Dear ${recipientName},
  %0D%0A
  %0D%0A ${senderName} was admiring this and thought you might like to know.
  %0D%0A
  %0D%0A xx,
  %0D%0A Your friends at Irene Neuwirth
  %0D%0A
  %0D%0A ${productTitle}
  %0D%0A ${productUrl}`;

	const hintHref = "mailto:" + recipientEmail + '?subject=' + hintSubject + '&body=' + hintBody;
	let link = document.createElement('A');
	link.href = hintHref;
	link.click();
	link = null;
	hint.dataset.show = 'false';
}

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/
const init = () => {
	Logger.info(`${NAME} > init`);

	document.querySelectorAll('.theme-accordian').forEach(el => new ThemeAccordian(el));
	document.querySelectorAll('[data-ring-chart-btn]').forEach(btn => btn.addEventListener('click', () => onPopUpBtn(chart)));
	document.querySelectorAll('[data-hint-popup-btn]').forEach(btn => btn.addEventListener('click', () => onPopUpBtn(hint)));
	hintForm.onsubmit = onHintFormSubmit;

	initAddToCartButtons();
	initCartListeners();
	initCarousel();
	initNotifyForm();
}

/**
 * disableCartActions - Disable all cart actions temporarily
 */
const disableCartActions = () => {
	Logger.info(`${NAME} > disableCartActions`);

	addToCartButtonDoms.forEach((button) => {
		button.disabled = true;
	});
};

/**
 * enableCartActions - Disable all cart actions temporarily
 */
const enableCartActions = () => {
	Logger.info(`${NAME} > enableCartActions`);

	addToCartButtonDoms.forEach((button) => {
		button.disabled = false;
	});
};

/**
 * initAddToCartButtons - Initialize all add to cart buttons
 */
const initAddToCartButtons = () => {
	Logger.info(`${NAME} > initAddToCartButtons`);

	addToCartButtonDoms.forEach((button) => {
		button.addEventListener("click", (e) => {
			e.preventDefault();
			global.cart.add([
				{
					id: selectedVariantDom.value,
					quantity: 1,
				},
			]);
		});
	});
};

/**
 * initCartListeners - Initialize all listeners on the cart
 */
const initCartListeners = () => {
	Logger.info(`${NAME} > initCartListeners`);

	// Disable buttons when cart is processing
	global.cart.on("cart.adding", () => {
		disableCartActions();
	});

	// Reset the page when the product is added to cart
	global.cart.on("cart.added", () => {
		resetCartActions();
	});
};

/**
 * initCarousel - Initialize the carousel
 */
const initCarousel = () => {
	Logger.info(`${NAME} > initCarousel`);
	let carousel;
	const onResize = () => {
		if (window.innerWidth < 1024 && !carousel) {
			carousel = new SimpleCarousel(carouselEl, 300, 'product__images-pagination-dot', {
				tapAdvance: true,
			});
		}
		if (window.innerWidth >= 1024 && carousel) {
			carousel.kill();
			carousel = null;
		}
	}
	window.addEventListener('resize', onResize);
	onResize();
}

/**
 * initNotifyForm - Initialize the notify form
 */
const initNotifyForm = () => {
	Logger.info(`${NAME} > initNotifyForm`);

	// Get the notify form elements
	const notifyFields = notify.querySelector('.notify__fields');
	const signupBtn = notify.querySelector('#notify_signup_btn');
	const closeBtn = notify.querySelector('.product__notify .close');

	const now = notify.getAttribute(`data-now`);
	const nowAt = notify.getAttribute(`data-now-at`);
	const productTitle = notify.getAttribute(`data-product-title`);
	const productUrl = notify.getAttribute(`data-product-url`);
	const variantTitle = notify.getAttribute(`data-variant-title`);

	const nowKey = `notify_${now}`;
	const nowAtKey = `notify_${nowAt}`;

	// Handle the notify form submit
	window.KlaviyoSubscribe.attachToForms(notifyForm, {
		success_message: "Thank you for your note.<br>We will be in touch shortly.",
		hide_form_on_success: true,
		extra_properties: {
			$source: productUrl,
			$method_type: "Sold Out Notification Form",
			$method_id: 'embed',
			$consent_version: 'Embed default text',
			[nowAtKey]: `${productTitle} / ${variantTitle}`,
			[nowKey]: `${productTitle} / ${variantTitle}`,
			$notify_status: `${productTitle} / ${variantTitle} at ${now}`,
		},
		success: function ($form) {
			notifyFields.style.display = 'none';
			signupBtn.value = 'Submitted';
			signupBtn.disabled = true;
			setTimeout(function () {
				onPopUpBtn(notify);
				signupBtn.value = 'Notify Me';
				signupBtn.disabled = false;
				notifyFields.style.display = 'initial';
				const successMessage = notify.querySelector('.success_message');
				successMessage.innerHTML = '';
			}, 3000);
		}
	});

	// Setup button and form events
	document.querySelectorAll('[data-notify-popup-btn]').forEach(btn => btn.addEventListener('click', () => onPopUpBtn(notify)));
	closeBtn.addEventListener('click', () => onPopUpBtn(notify));
}

/**
 * resetCartActions - Reset the page cart actions and values to beginning
 */
const resetCartActions = () => {
	Logger.info(`${NAME} > resetCartActions`);
	enableCartActions();
};

// Bootstrap global functionality
global = Global();

// Bootstrap page-specific functionality
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
